import { useContext, useMemo } from "react";
import { StylesContext } from "../../../contexts/styles-context/styles.context";
import { Button } from "../../common/button/button";
import { PopupWindow } from "../popup-window/popup-window";
import styles from "./instruction-popup.module.scss";
import { appConfig } from '../../../config/app.config';
import { useAppSelector } from '../../../hooks/redux.hook';
import { analyticsService } from "../../../analytics.service";
import { AnalyticsEvent } from "../../../enums/analytics-event.enum";

interface InstructionPopupProps {
  active: boolean;
  onClose?: () => void;
  onButtonClick?: () => void;
}

export function InstructionPopup({ active, onClose, onButtonClick }: InstructionPopupProps) {
  const { styles: { allButtons = {}, primaryButtons = {} } } = useContext(StylesContext);
  const { whatsappInstruction } = useAppSelector(state => state.content.currentContent);
  const imgUrl = useMemo(() => {
    const path = whatsappInstruction?.image?.url || '/img/wa_instruction.jpg'
    return appConfig().assets_url + path;
  }, [whatsappInstruction]);

  const clickHandler = () => {
    onButtonClick && onButtonClick();
    analyticsService.send(AnalyticsEvent.CLICK_BUTTON_IN_WHATSAPP_INSTRUCITON);
  }

  const closeHandler = () => {
    onClose && onClose();
    analyticsService.send(AnalyticsEvent.CLOSE_WHATSAPP_INSTRUCTION);
  }

  return (
    <PopupWindow active={active} onClose={closeHandler} showCloseButton={true}>
      <div className={styles.container}>
        <h2 className={styles.header}>
          {whatsappInstruction?.header || "Перейдите в whatsapp и отправьте сообщение"}
        </h2>
        <img className={styles.image} src={imgUrl} alt="" />
        <Button
          customStyles={{ ...allButtons, ...primaryButtons }}
          value={"Перейти в whatsapp"}
          mode="whatsApp"
          onClick={clickHandler}
        />
        <span className={styles.underButtonText}>
          Если whatsApp не открывается, то закройте это попап окно и оставьте заявку в форме
        </span>
      </div>
    </PopupWindow>
  )
}